import { createStore } from 'vuex'

import actions from './actions'
import mutations from './mutations'
import getters from './getters'
import defaultState from './state'

export default function buildStore() {
  const el = document.querySelector('.vue-component-loader[data-component-name=petitionStartForm]')
  const { currentStep, ...initialState } = JSON.parse(el.dataset.storeData)

  const state = {...defaultState, ...initialState}

  const store = createStore({
    state,
    getters,
    mutations,
    actions
  })

  store.commit('setCurrentField', currentStep)

  return store
}
